// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-js{width:100%;height:100%}@media (min-width:1520px){.branner_div_title{font-size:44.8px}}@media (max-width:1520px){.branner_div_title{font-size:40px}}@media (min-width:768px){.new_footer{display:block}.new_footer_padding{display:none}.map_content_two{margin-left:20%}.map_content_one{margin-right:0}.map_div{min-height:950px}.branner_div_button_div{display:block}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
